// store/classrooms.js
export function state() {
  return {
    byCity: {},   // { london: [...] }
    byDays: {}    // { '2': [...], '3': [...] }
  }
}

export const mutations = {
  setCity(state, p) {
    console.log('SETCITY key=[' + p.city + '] rows=' + ((p.data && p.data.length) || 0))
    state.byCity = Object.assign({}, state.byCity, { [p.city]: p.data })
  },
  setDays(state, p) {
    state.byDays = Object.assign({}, state.byDays, { [p.days]: p.data })
  }
}

export const actions = {
    // store/classrooms.js — fetchCity, shaping the parts that don't need Vue filters
    async fetchCity({ commit, rootGetters }, city) {
    console.log('FETCHCITY called with:', JSON.stringify(city))
    if (!city) return []
    const key = String(city).toLowerCase()
    const label = rootGetters['cart/getPriceLabel'] || 'TEFLORG'
    const excluded = [9, 11101, 11103, 152, 10173, 151, 10169]
    try {
        let data = await this.$axios.$get(
        process.env.DATA_URL + '/classroom/city/' + city +
        (label ? ('?productPriceLabel=' + label) : '')
        )
        // console.log('CLASSROOM RAW[0]:', JSON.stringify((data && data[0]) || {}, null, 2))
        data = (data || []).map(function (c) {
        const places = c.maxAttendees - c.numAttendees
        return Object.assign({}, c, {
            places,
            products: (c.products || []).filter(function (p) {
            return !excluded.includes(p.id)
            })
        })
        })
        commit('setCity', { city: key, data })
        return data
    } catch (e) {
        commit('setCity', { city: key, data: [] })
        return []
    }
    },

  async fetchDays({ commit }, days) {
    if (!days) return []
    const key = String(days)
    try {
      let data = await this.$axios.$get(process.env.DATA_URL + '/classroom/days/' + days)
      data = data || []
      // console.log('CLASSROOM DAYS RAW[0]:', JSON.stringify((data && data[0]) || {}, null, 2))
      commit('setDays', { days: key, data })
      return data
    } catch (e) {
      commit('setDays', { days: key, data: [] })
      return []
    }
  }
}

export const getters = {
  forCity: (state) => (city) => {
    const k = String(city || '').toLowerCase()
    console.log('FORCITY key=[' + k + '] rows=' + ((state.byCity[k] || []).length))
    return state.byCity[k] || []
},
  forDays: (state) => (days) => state.byDays[String(days || '')] || []
}